import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTurbineAgitator = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 36,
	height: 93.4,
	viewBox: "0 0 36.0 93.4",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M 24.0 2.4 L 24.0 27.4 A 5.0 2.0 0.0 0 1 12.0 27.4 L 12.0 2.4 A 5.0 2.0 0.0 0 1 24.0 2.4 Z M 12.0 2.4 L 24.0 2.4 M 12.0 27.4 L 24.0 27.4",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 17,
			y: 29.9,
			width: 2,
			height: 57.5,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 8,
			y: 87.4,
			width: 20,
			height: 2,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 0,
			y: 83.4,
			width: 8,
			height: 10,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 28,
			y: 83.4,
			width: 8,
			height: 10,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		})
	]
});
export default SvgTurbineAgitator;
